import { connect } from 'react-redux'
import BulkAction from './bulk-actions'
import {
  deleteWork,
  fetchWorks
} from '../../../../../../stores/works/works.actions'
import { openCreateAssessmentDialog } from '../../../dialogs/create-assessment/create-assessment.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getPagination } from '../../../../../../stores/works/works.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = state => ({
  pagination: getPagination(state)
})

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onDelete: works =>
    Promise.all(
      works.map(work => dispatch(deleteWork(work.id)).catch(errorHandler))
    ).then(() =>
      dispatch(
        fetchWorks(ownProps.match.params.id, {
          page: stateProps.pagination.current
        })
      )
    ),
  onOpenCreateAssessmentDialog: works =>
    dispatch(openCreateAssessmentDialog(works))
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(BulkAction)
)
